var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"viewBox":"0 0 147 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 8C0 3.58172 3.58172 0 8 0H130.577C133.275 0 135.791 1.35977 137.269 3.6166L145.129 15.6166C146.873 18.2788 146.873 21.7213 145.129 24.3834L137.269 36.3834C135.791 38.6402 133.275 40 130.577 40H8C3.58172 40 0 36.4183 0 32V8Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }